import { Box, Tab } from '@mui/material';
import { TCustomTabProps } from '../../utils/types';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import './index.scss';
import {
  FilterList,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@mui/icons-material';

export const CustomTab = <T, K extends keyof T>({
  activeTab,
  tabList,
  valueKey,
  labelKey,
  tabPanel,
  onTabChange,
  iconKey,
  showFilterButton,
  filtersIsCollapsed,
  handleFilterButtonClick,
  main,
  fontsize,
}: TCustomTabProps<T, K>) => {
  const handleChange = (
    _event: React.SyntheticEvent<Element, Event>,
    value: string
  ) => {
    const newActiveTab = tabList.find(
      (ele) => ele[valueKey] == value
    );
    if (newActiveTab) {
      onTabChange(newActiveTab);
    }
  };

  return (
    <Box>
      <TabContext value={activeTab[valueKey] as string}>
        <Box
          className={main ? 'tab-list-box -mt-6' : 'mt-6'}
          sx={{ backgroundColor: '#fff' }}>
          <TabList
            onChange={handleChange}
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: '#006970', // Custom indicator color
              },
              '& .MuiTab-root': {
                color: '#000', // Default tab color
                fontSize: fontsize ? fontsize : 15,
                '&.Mui-selected': {
                  color: '#006970', // Active tab color
                },
              },
            }}
            variant="scrollable"
            scrollButtons="auto">
            {showFilterButton && (
              <Tab
                label={
                  <Box
                    sx={{
                      padding: '8px',
                      border: '1px solid #006970',
                      borderRadius: '5px',
                      backgroundColor:
                        filtersIsCollapsed == true
                          ? '#006970'
                          : '#00697014',
                      color:
                        filtersIsCollapsed == true
                          ? '#FFFFFF'
                          : '#006970',
                    }}>
                    <FilterList
                      sx={{
                        marginRight: '10px',
                        marginLeft: '10px',
                      }}
                    />
                    Filters
                    {filtersIsCollapsed == true ? (
                      <KeyboardArrowDown
                        sx={{
                          marginLeft: '10px',
                          marginRight: '10px',
                        }}
                      />
                    ) : (
                      <KeyboardArrowUp
                        sx={{
                          marginLeft: '10px',
                          marginRight: '10px',
                        }}
                      />
                    )}
                  </Box>
                }
                onClick={() =>
                  handleFilterButtonClick
                    ? handleFilterButtonClick(
                        filtersIsCollapsed == true
                          ? false
                          : true
                      )
                    : {}
                }
              />
            )}
            {tabList.map((tab) => (
              <Tab
                className="tat-link"
                key={tab[valueKey] as string}
                label={tab[labelKey] as string}
                value={tab[valueKey] as string}
                icon={
                  iconKey
                    ? (tab[iconKey] as React.ReactElement)
                    : undefined
                }
                iconPosition="start"
              />
            ))}
          </TabList>
        </Box>
        {tabList.map((tab) => (
          <TabPanel
            key={tab[valueKey] as string}
            value={tab[valueKey] as string}>
            {tabPanel(tab)}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};
